import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  OnChanges
} from "@angular/core";
import { DecimalPipe } from "@angular/common";
import * as d3 from "d3";
import { SharedUtils } from "../../../../../shared/shared.utils";
import { SessionStateService } from "../../../../../core/services/session-state.service";

@Component({
  selector: "app-donut-chart",
  styleUrls: ["./donut-chart.component.scss"],
  template: `
    <div
      [ngClass]="{
        'donut-chart-gen': type === 'Generation',
        'donut-chart-cons': type === 'Consumption'
      }"
      #donutChartContainer
    ></div>
  `
})
export class DonutChartComponent implements OnInit, OnChanges {
  @ViewChild("donutChartContainer") private chartContainer: ElementRef;
  hostElement: any;
  svg: any;

  @Input()
  dataset: any[];
  @Input()
  type: string;
  @Input() totalizersContainerLen: number;
  @Input() isOnline: boolean;

  SharedUtils = SharedUtils;

  size: number;
  outerRadius;
  number;
  innerRadius: number;

  donutDataset;
  emptyDataset = [
    {
      color: "#ececec",
      value: 1
    },
    {
      color: "#ececec",
      value: 0
    }
  ];

  constructor(private elementRef: ElementRef, 
    private sessionStateService: SessionStateService,
    private decimalPipe: DecimalPipe) {}

  ngOnInit() {
    this.hostElement = this.chartContainer.nativeElement;

    const pie = d3
      .pie()
      .value(function(d) {
        return d.value;
      })
      .sort(null);
    // .padAngle(.03);

    this.size = (this.totalizersContainerLen - 2 * 36) * 0.4;
    // this.size = this.size > 180 ? 180 : this.size;
    const w = this.size,
      h = this.size;

    this.outerRadius = this.size * 0.46;
    this.innerRadius = this.outerRadius - 4;

    const color = d3.schemeCategory10;

    const arc = d3
      .arc()
      .outerRadius(this.outerRadius)
      .innerRadius(this.innerRadius);

    this.svg = d3
      .select(this.hostElement)
      .append("svg")
      .attr("width", w)
      .attr("height", h)
      .append("g")
      .attr(
        "transform",
        "translate(" + this.size / 2 + "," + this.size / 2 + ")"
      );

    const g = this.svg
      .selectAll(".arc")
      .data(pie(this.dataset))
      .enter()
      .append("g");

    g.append("path")
      .attr("d", arc)
      .attr("fill", function(d, i) {
        return d.data.color;
      })
      .transition()
      .duration(1000)
      .attrTween("d", function(d) {
        const interpolate = d3.interpolate({ startAngle: 0, endAngle: 0 }, d);
        return function(t) {
          return arc(interpolate(t));
        };
      });

    // If is online ==> Show Text. When text is not supposed to be shown text = ''
    // Otherwise ==> Show Icon. When icon is not supposed to be shown height = '0px'
    const textSize = window.innerWidth < 1460 ? "18" : "20";
    g.append("text")
      .attr("text-anchor", "middle")
      .attr("font-family", "Roboto")
      .attr("font-size", textSize)
      .attr("fill", this.dataset[1].color)
      .attr("y", 10)
      .text(
        (this.dataset[0].value === null || this.dataset[1].value === null
          ? "- "
          : this.convertToLocaleFormat(SharedUtils.getEnergy(
              this.dataset[0].value + this.dataset[1].value
            ))) +
          " " +
          SharedUtils.getEnergyUnit(
            this.dataset[0].value + this.dataset[1].value
          )
      );
    g.append("svg:image") //alert.svg
      .attr("xlink:href", "./assets/img/icons/alert.svg")
      .attr("height", "0px") //Hammer time ==> with height === 0, is when icon is hidden
      .attr("x", "-26px")
      .attr("y", "-26px");

    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.svg) {
      // If no value exists, fill all donut with gray
      if (!this.dataset || (!this.dataset[0].value && !this.dataset[1].value)) {
        this.donutDataset = this.emptyDataset;
      } else {
        this.donutDataset = this.dataset;
      }

      const pie = d3
        .pie()
        .value(function(d) {
          return d.value;
        })
        .sort(null);
      // .padAngle(.03);

      const color = d3.schemeCategory10;

      const arc = d3
        .arc()
        .outerRadius(this.outerRadius)
        .innerRadius(this.innerRadius);

      this.svg
        .selectAll("path")
        .data(pie(this.donutDataset))
        .attr("d", arc)
        .attr("fill", function(d, i) {
          return d.data.color;
        })
        .transition(1000);

      // Needed since in JS null + null = 0 -.-'
      let newValue = null;
      if (this.dataset[0].value !== null || this.dataset[1].value !== null) {
        newValue = this.dataset[0].value + this.dataset[1].value;
      }

      // If is online ==> Show Text
      if (this.isOnline) {
        this.svg
          .selectAll("text")
          .text(
            (newValue === null ? "- " : this.convertToLocaleFormat(SharedUtils.getEnergy(newValue))) +
              " " +
              SharedUtils.getEnergyUnit(newValue)
          );
        this.svg.selectAll("image").attr("height", "0px");
      } // If is offline, show an icon
      else if (this.isOnline === false) {
        this.svg.selectAll("text").text("");
        this.svg.selectAll("image").attr("height", "50px");
      }
    }
  }

  convertToLocaleFormat(number): string {
    return this.decimalPipe.transform(
      number,
      "1.0-2",
      this.sessionStateService.getLang()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/home/home-tab/home-cells-view/donut-chart/donut-chart.component.ts